module.exports = __webpack_public_path__ + "static/media/dribbble-square.ba0d0530.svg";